module.exports = __webpack_public_path__ + "static/scale-model-of-joliet-iron-works-park-in-joliet-illinois-290dbb9b9ac35625a1ac1d25fe7bc7c3.png";